// src/pages/SetPassword.js
import React, { useState, useEffect } from 'react';
import { useSearchParams, Link, useNavigate } from 'react-router-dom';
import Button from '../components/Button';

export default function SetPassword() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const emailFromUrl = searchParams.get('user') || '';
  const tokenFromUrl = searchParams.get('token') || '';

  const [email, setEmail] = useState(emailFromUrl);
  const [token, setToken] = useState(tokenFromUrl);
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  // keep state in sync if URL changes
  useEffect(() => {
    setEmail(emailFromUrl);
    setToken(tokenFromUrl);
  }, [emailFromUrl, tokenFromUrl]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (!email || !token) {
      setError('This reset link is invalid or incomplete.');
      return;
    }

    if (password.length < 6) {
      setError('Password should be at least 6 characters long.');
      return;
    }

    if (password !== confirm) {
      setError('Passwords do not match.');
      return;
    }

    setLoading(true);

    try {
      const res = await fetch('https://kepithor.xyz/set_password_reset.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({
          email,
          token,
          password,
        }).toString(),
      });

      if (!res.ok) {
        throw new Error('Unable to set password. Please try again.');
      }

      let data = null;
      try {
        data = await res.json();
        console.log(data);
      } catch {
        // if not JSON, ignore and just use generic messages
      }

      if (data && (data.success || data.status === 'ok')) {
        setSuccess(data.message || 'Your password has been updated successfully.');
        // optional: redirect to login after a short delay
        setTimeout(() => {
          navigate('/login', { replace: true });
        }, 1500);
      } else if (data && (data.error || data.message)) {
        setError(data.error || data.message);
      } else {
        setSuccess('Your password has been updated successfully.');
        setTimeout(() => {
          navigate('/login', { replace: true });
        }, 1500);
      }
    } catch (err) {
      setError(err.message || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const linkInvalid = !emailFromUrl || !tokenFromUrl;

  return (

<>

        <div className="spacer" style={{height: 20}}></div>

    <div className="mx-auto max-w-md bg-slate-900/70 border border-slate-800 rounded-2xl p-6 shadow-xl shadow-emerald-500/10">
      <h1 className="text-2xl font-bold mb-2">Set a new password</h1>

      {linkInvalid && (
        <div className="mb-4 text-sm text-red-400">
          This password reset link is missing required information. Please click/follow the link in your email again.
        </div>
      )}

      <p className="text-sm text-slate-300 mb-4">
        Choose a new password for your account.
      </p>

      <form onSubmit={handleSubmit} className="grid gap-3">
        {/* Email (read-only, just to show the user) */}
        <label className="grid gap-1">
          <span className="text-sm text-slate-300">Email</span>
          <input
            className="border border-slate-700 bg-slate-950/60 rounded-xl px-3 py-2 text-sm text-slate-100 placeholder:text-slate-500 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500"
            type="email"
            value={email}
            readOnly
          />
        </label>

        {/* New password */}
        <label className="grid gap-1">
          <span className="text-sm text-slate-300">New password</span>
          <input
            className="border border-slate-700 bg-slate-950/60 rounded-xl px-3 py-2 text-sm text-slate-100 placeholder:text-slate-500 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            disabled={linkInvalid}
            required
          />
        </label>

        {/* Confirm password */}
        <label className="grid gap-1">
          <span className="text-sm text-slate-300">Confirm password</span>
          <input
            className="border border-slate-700 bg-slate-950/60 rounded-xl px-3 py-2 text-sm text-slate-100 placeholder:text-slate-500 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500"
            type="password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            disabled={linkInvalid}
            required
          />
        </label>

        {error && <div className="text-red-400 text-sm">{error}</div>}
        {success && <div className="text-emerald-400 text-sm">{success}</div>}

        <Button
          disabled={loading || linkInvalid}
          className="bg-emerald-500 text-grey hover:bg-emerald-400"
        >
          {loading ? 'Updating password…' : 'Update password'}
        </Button>

        <div className="text-sm mt-2 text-slate-300">
          Back to{' '}
          <Link to="/login" className="text-emerald-300 underline">
            sign in
          </Link>
        </div>
      </form>
    </div>

</>


  );
}
